import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { SearchWrapper } from './styles';
import { ZendeskHelpMobileSearchModal } from './ZendeskHelpMobileSearchModal';
import { toggleChat } from '../../../actions/chatAction';
import { PromoInputSearch } from '../form/PromoInputPhoneWithDropdown/PromoInputSearch';

const ZendeskHelpMobileSearch = (props) => {
    const wrapperRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const [fullViewSearch, setFullViewSearch] = useState(false);

    const toggleSearch = (e, show) => {
        e.preventDefault();
        setFullViewSearch(show);
    };

    const handleToggleChat = (e) => {
        e.preventDefault();
        props.isMobilePlatform ? navigate(`${location.pathname}/showChat`) : props.toggleChat(true);
    };

    return (
        <SearchWrapper ref={wrapperRef}>
            <PromoInputSearch placeholder={props.searchPlaceholder} toggle={toggleSearch} />
            {fullViewSearch && (
                <>
                    <ZendeskHelpMobileSearchModal
                        sections={props.sections}
                        lang={props.lang}
                        country={props.country}
                        searchPlaceholder={props.searchPlaceholder}
                        searchNoResult={props.searchNotFound}
                        chatButton={props.chatButton}
                        toggleChat={(e) => handleToggleChat(e)}
                        toggleSearch={(e) => toggleSearch(e, false)}
                    />
                </>
            )}
        </SearchWrapper>
    );
};

const mapStateToProps = ({ extra }) => {
    return {
        sections: extra?.zendeskHelpData?.sections,
        searchPlaceholder: extra?.strapiApi?.search_placeholder,
        searchNotFound: extra?.strapiApi?.search_not_found_mobile,
        chatButton: extra?.strapiApi?.chat_btn_mobile,
        lang: extra.noAuthFooter?.language?.lang,
        country: extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps, { toggleChat })(ZendeskHelpMobileSearch);
